import { Box, Dialog, DialogContent, IconButton, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useState } from 'react';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import appTheme from '../../../common/theme/appTheme.json';
import Disclaimer from './Disclaimer';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      top: '52px !important',
      left: '52px !important',
      position: 'absolute',
      width: 'calc(100vw - 52px)',
      height: 'calc(100vh - 52px)',
    },
    dialogContent: {
      backgroundColor: appTheme.primaryBackgroundColor,
      color: appTheme.primaryTextColor,
      padding: '0 40px',
    },
    disclosureDiv: {
      color: appTheme.externalLinkColor,
      cursor: 'pointer',
    },
    thePaper: {
      backgroundColor: appTheme.primaryBackgroundColor,
    },
  }),
);
export interface DisclaimerButtonProps {}
const DisclaimerButton = (props: DisclaimerButtonProps) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <div
        className={classes.disclosureDiv}
        onClick={() => {
          setOpen(true);
        }}
      >
        Disclaimer
      </div>
      <Dialog
        fullScreen
        className={classes.dialog}
        classes={{ paper: classes.thePaper }}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogContent>
          <div className={classes.dialogContent}>
            <Box display="flex" justifyContent="flex-end">
              <IconButton
                color="inherit"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <CloseRoundedIcon />
              </IconButton>
            </Box>
            <Disclaimer />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default DisclaimerButton;
